<nav #navpafar class="navbar navbar-expand-lg navbar-light bg-light sticky-nav" [class.active]="classApplied" [class.sticky-box-shadow]="displayLogo">
  <div class="container">
    <div class="content-logo">
      <!--<a class="navbar-brand" routerLink="/"><span>P</span>afar</a>-->
      @if (!displayLogo) {
        <a class="navbar-brand" href="/" (click)="goHome($event)"><img src="assets/images/logo_pafar_blanco.png" [attr.alt]="'nav.logoAlt' | translate"></a>
      }
      @if (displayLogo) {
        <a class="navbar-brand" href="/" (click)="goHome($event)"><img src="assets/images/logo_pafar_color.png" [attr.alt]="'nav.logoAlt' | translate"></a>
      }

    </div>
    <div class="nav-actions">
      <div class="lang-dropdown" #langDropdownRef>
        <button
          type="button"
          class="lang-trigger"
          (click)="toggleLangDropdown($event)"
          [attr.aria-label]="'nav.language' | translate"
          [attr.aria-expanded]="langDropdownOpen"
          aria-haspopup="listbox">
          <img class="lang-flag" [src]="currentFlagSrc" [alt]="languageService.currentLang()">
          <span class="lang-code">{{ languageService.currentLang() | uppercase }}</span>
          <i class="fas fa-chevron-down lang-caret" [class.open]="langDropdownOpen"></i>
        </button>
        <ul class="lang-menu" [class.show]="langDropdownOpen" role="listbox">
          <li>
            <button type="button" class="lang-option" [class.active]="languageService.is('es')" (click)="selectLanguage('es')">
              <img class="lang-flag" src="assets/images/flags/es.svg" alt="">
              <span>{{ 'nav.langEs' | translate }}</span>
            </button>
          </li>
          <li>
            <button type="button" class="lang-option" [class.active]="languageService.is('en')" (click)="selectLanguage('en')">
              <img class="lang-flag" src="assets/images/flags/en.svg" alt="">
              <span>{{ 'nav.langEn' | translate }}</span>
            </button>
          </li>
        </ul>
      </div>
      <button class="navbar-toggler" type="button" (click)="toggleClass()">
        <span class="burger-menu">
          <span class="top-bar"></span>
          <span class="middle-bar"></span>
          <span class="bottom-bar"></span>
        </span>
      </button>
    </div>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item"><span class="nav-link" (click)="onClick('home')">{{ 'nav.home' | translate }}</span></li>
        <li class="nav-item"><span class="nav-link" (click)="onClick('about')">{{ 'nav.about' | translate }}</span></li>
        <li class="nav-item"><span class="nav-link" (click)="onClick('team')">{{ 'nav.alliances' | translate }}</span></li>
        <li class="nav-item dropdown-nav" #servicesDropdownRef>
          <span class="nav-link nav-link-toggle" (click)="toggleServicesDropdown()">{{ 'nav.productsServices' | translate }} <i class="fas fa-chevron-down dropdown-arrow" [class.open]="servicesDropdownOpen"></i></span>
          <ul class="dropdown-menu-nav" [class.show]="servicesDropdownOpen">
            <li><span class="nav-link dropdown-item-nav" (click)="goToServiceSection('services-productos')">{{ 'nav.products' | translate }}</span></li>
            <li><span class="nav-link dropdown-item-nav" (click)="goToServiceSection('services-software')">{{ 'nav.services' | translate }}</span></li>
          </ul>
        </li>
        <li class="nav-item"><span class="nav-link" (click)="onClick('blog')">{{ 'nav.representations' | translate }}</span></li>
        <li class="nav-item"><span class="nav-link" (click)="onClick('partner')">{{ 'nav.offices' | translate }}</span></li>
        <li class="nav-item"><span class="nav-link" (click)="onClick('contact')">{{ 'nav.contact' | translate }}</span></li>
      </ul>
      <ul class="navbar-nav ml-auto for-responsive">
        <li class="nav-item"><span class="nav-link" (click)="toggleClass(); onClick('home')">{{ 'nav.home' | translate }}</span></li>
        <li class="nav-item"><span class="nav-link" (click)="toggleClass(); onClick('about')">{{ 'nav.about' | translate }}</span></li>
        <li class="nav-item"><span class="nav-link" (click)="toggleClass(); onClick('team')">{{ 'nav.alliances' | translate }}</span></li>
        <li class="nav-item dropdown-nav responsive-dropdown" #servicesDropdownRefResponsive>
          <span class="nav-link nav-link-toggle" (click)="toggleServicesDropdown()">{{ 'nav.productsServices' | translate }} <i class="fas fa-chevron-down dropdown-arrow" [class.open]="servicesDropdownOpen"></i></span>
          <ul class="dropdown-menu-nav" [class.show]="servicesDropdownOpen">
            <li><span class="nav-link dropdown-item-nav" (click)="goToServiceSection('services-productos'); toggleClass()">{{ 'nav.products' | translate }}</span></li>
            <li><span class="nav-link dropdown-item-nav" (click)="goToServiceSection('services-software'); toggleClass()">{{ 'nav.services' | translate }}</span></li>
          </ul>
        </li>
        <li class="nav-item"><span class="nav-link" (click)="toggleClass(); onClick('blog')">{{ 'nav.representations' | translate }}</span></li>
        <li class="nav-item"><span class="nav-link" (click)="toggleClass(); onClick('partner')">{{ 'nav.offices' | translate }}</span></li>
        <li class="nav-item"><span class="nav-link" (click)="toggleClass(); onClick('contact')">{{ 'nav.contact' | translate }}</span></li>
      </ul>
    </div>
  </div>
</nav>
